export const getWidthMinMediaQuery = (width: number): string => {
  return `(min-width: ${`${width}px`})`;
};

const Breakpoints = {
  lg: 1024,
  md: 720,
  sm: 576,
  ultra: 1920,
  xl: 1344,
  xs: 480,
  xxs: 410,
};

export const MOBILE_BREAKPOINT = '720px';

export const screenXxsMin = getWidthMinMediaQuery(Breakpoints.xxs);
export const screenXsMin = getWidthMinMediaQuery(Breakpoints.xs);
export const screenSmMin = getWidthMinMediaQuery(Breakpoints.sm);
export const screenMdMin = getWidthMinMediaQuery(Breakpoints.md);
export const screenLgMin = getWidthMinMediaQuery(Breakpoints.lg);
export const screenXlMin = getWidthMinMediaQuery(Breakpoints.xl);
export const screenUltraMin = getWidthMinMediaQuery(Breakpoints.ultra);

export const mobileScreen = 991;
export const mdDesktopScreen = 1200;

export default Breakpoints;
